// extracted by mini-css-extract-plugin
export default {"testimonialsContainer":"styles_testimonialsContainer__ULgjM","ttl":"styles_ttl__SAbMq","zigzag":"styles_zigzag__x4Opy","vidWrap":"styles_vidWrap__VItyG"};